module.exports = __webpack_public_path__ + "img/header-profile.2a634a94.png";